// Shared between TopNav's search dropdown and the full SearchResultsPage --
// one place to decide what a single search result row actually displays,
// per entity type.
export function formatSearchResultLabel(type, item) {
  switch (type) {
    case 'customer':
      return item.name;
    case 'vehicle':
    case 'replacementvehicle':
      return [item.licensePlate, [item.make, item.model].filter(Boolean).join(' ')].filter(Boolean).join(' · ');
    case 'workorder':
      return [item.workOrderNumberDisplay, item.description].filter(Boolean).join(' · ');
    case 'reservation':
      return [item.reservationNumberDisplay, item.vehicleLicensePlate, item.customerName].filter(Boolean).join(' · ');
    case 'invoice':
      return [item.invoiceNumberDisplay, item.customerName].filter(Boolean).join(' · ');
    case 'document':
      return item.filename;
    default:
      return item.name || item.id;
  }
}
